<template>
  <div class="layout-container">
    <Header></Header>
    <!-- <Menus></Menus> -->
    <router-view class="router-container"></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import Menus from '@/components/menus'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
  name: 'Layout',
  components: {
    Header,
    Menus,
    Footer
  },
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.layout-container {
  span {
    display: inline-block;
  }
  .router-container {
    min-height: 980px;
  }
  .menus {
    height: 60px;
    padding: 0 0px;
    background: #1766aa;
    width: 100%;
    display: flex;
    .menu-item {
      // width: 176px;
      flex: 1;
      // padding: 0 60px;
      height: 60px;
      text-align: center;
      line-height: 60px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      cursor: pointer;
    }
    .active {
      background: rgba(255, 255, 255, 0.2);
    }
  }
  .menus-children {
    padding: 0 160px;
    height: 52px;
    width: 100%;
    overflow: hidden;
    cursor: pointer;
    .menu-children-item {
      width: 176px;
      font-size: 16px;
      text-align: center;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #141f33;
      line-height: 52px;
      &:hover {
        color: #5e7ed4;
      }
    }
  }
}
</style>
